// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__MSxUR","load":"loading_load__-r4NP","loading-overlay":"loading_loading-overlay__5g806"};